module.exports = __webpack_public_path__ + "img/bananos.20fc2ad8.svg";